{
  "basicTerms": {
    "selectedOfTotal": "{selected}/{total} sélectionnés",
    "search": "Rechercher",
    "summary": "Résumé",
    "insights": "Aperçus",
    "help": "Aide",
    "expand": "Développer",
    "collapse": "Réduire",
    "menu": "Menu",
    "account": "Compte",
    "logout": "Déconnexion",
    "signIn": "Connexion",
    "days": "Jour | Jours",
    "phone": "Téléphone",
    "subscribers": "Abonné | Abonnés",
    "favorites": "Favori | Favoris",
    "others": "Autre | Autres",
    "yes": "Oui",
    "no": "Non",
    "locations": "Emplacement | Emplacements",
    "active": "Actif",
    "inactive": "Inactif",
    "all": "Tous",
    "view": "Voir",
    "language": "Langue",
    "required": "Requis",
    "timezone": "Fuseau horaire",
    "new": "Nouveau",
    "open": "Ouvert",
    "close": "Fermer",
    "closed": "Fermé",
    "occupied": "Occupé",
    "reserved": "Réservé",
    "enabled": "Activé",
    "disabled": "Désactivé",
    "enable": "Activer",
    "disable": "Désactiver",
    "print": "Imprimer",
    "download": "Télécharger",
    "zoomIn": "Zoom avant",
    "zoomOut": "Zoom arrière",
    "previous": "Précédent",
    "next": "Suivant",
    "version": "Version",
    "setup": "Configuration",
    "caution": "Attention",
    "notes": "Note | Notes",
    "add": "Ajouter",
    "remove": "Supprimer",
    "duration": "Durée",
    "link": "Lier",
    "unlink": "Délier",
    "to": "à",
    "success": "Succès",
    "error": "Erreur",
    "info": "Infos",
    "warning": "Avertissement",
    "time": "Heure",
    "saved": "Enregistré",
    "forms": "Formulaire | Formulaires",
    "is": "est",
    "only": "Seulement",
    "saving": "Enregistrement",
    "text": "texte",
    "zip": "code postal",
    "spreadsheet": "feuille de calcul",
    "image": "Image",
    "cloning": "Clonage",
    "clone": "Cloner",
    "added": "Ajouté",
    "removed": "Supprimé",
    "planned": "Planifié",
    "unplanned": "Non planifié",
    "checkedIn": "Enregistré à l'arrivée",
    "checkedOut": "Enregistré à la sortie",
    "more": "Plus",
    "okay": "D'accord",
    "reschedule": "Replanifier",
    "results": "Résultat | Résultats",
    "none": "Aucun",
    "pages": "Page | Pages",
    "pageOfTotal": "Page {current} de {total}",
    "of": "de",
    "default": "Par défaut",
    "soon": "bientôt",
    "grid": "Grille",
    "list": "Liste",
    "booked": "Réservé",
    "arrivals": "Arrivée | Arrivées",
    "early": "Tôt",
    "late": "En retard",
    "onTime": "À l'heure",
    "area": "Zone | Zones",
    "spot": "Emplacement dans la cour",
    "single": "Unique",
    "multiple": "Multiple",
    "filter": "Filtrar",
    "board": "Tableau",
    "at": "à",
    "from": "de",
    "recent": "Récent",
    "delivered": "Livré",
    "sent": "Envoyé",
    "create": "Créer",
    "tasks": "Tâche | Tâches",
    "emails": "Courriel | Courriels",
    "passwords": "Mot de passe | Mots de passe",
    "limits": "Limites",
    "assignee": "Assigné",
    "comment": "Commentaire",
    "issue": "Problème",
    "urgent": "Urgent",
    "retry": "Réessayer",
    "custom": "Personnalisé",
    "na": "S/O"
  },
  "phrases": {
    "copyToClipboard": "Copier dans le presse-papiers",
    "copiedToClipboard": "Copié dans le presse-papiers",
    "warehouseAddress": "Adresse de l'entrepôt",
    "cloneSchedule": "Cloner l'horaire",
    "open24Hours": "Ouvert 24 heures",
    "featureEnabled": "Fonction activée",
    "featureDisabled": "Fonction désactivée",
    "learnMore": "En savoir plus",
    "minuteLabel": "{minutes} MIN",
    "minuteLabelFull": "{minutes} minutes",
    "thisActionCannotBeUndone": "cette action NE PEUT PAS être annulée",
    "areYouSure": "Êtes-vous sûr?",
    "unknownUser": "Utilisateur inconnu",
    "leaveWithoutSaving": "Quitter sans enregistrer",
    "learnHowItWorks": "Apprenez comment cela fonctionne",
    "allFields": "Tous les champs",
    "selectColumns": "Sélectionner les colonnes",
    "selectedColumns": "Colonnes sélectionnées",
    "addFiles": "Ajouter un fichier | Ajouter des fichiers",
    "tasks": "Aucune tâche | {count} tâche | {count} tâches",
    "driversSelfCheckin": "Auto-enregistrement du chauffeur",
    "addReferenceNumber": "Ajouter le numéro de référence",
    "myAccount": "Mon compte"
  },
  "messages": {
    "theConfirmationFieldDoesNotSupportPasting": "Le champ de confirmation ne permet pas le collage",
    "youMayHaveUnsavedChangesAreYouSureYouWantToLeaveThisPage": "Vous pourriez avoir des modifications non enregistrées, êtes-vous sûr de vouloir quitter cette page?",
    "browserDoesNotSupportCopyFunction": "Le navigateur ne prend pas en charge la fonction de copie",
    "permissionToAccessClipboardWasDeniedToEnableAccessUpdateYourBrowserSettings": "L’accès au presse-papiers a été refusé. Pour l’activer, modifiez les paramètres de votre navigateur.",
    "alternativelyYouCanManuallyCopy": "Sinon, vous pouvez copier manuellement",
    "areYouSureYouWantToLeaveYouMayHaveUnsavedChanges": "Êtes-vous sûr de vouloir quitter? Vous pourriez avoir des modifications non enregistrées.",
    "noResultsFound": "Aucun résultat trouvé",
    "maximumOfReferenceNumbersAllowedCountRemoved": "Un maximum de {maxItems} numéros de référence est autorisé. {removedCount} supprimé(s)"
  },
  "fileFormats": {
    "jpeg": "jpeg",
    "jpg": "jpg",
    "png": "png",
    "webp": "webp",
    "pdf": "pdf"
  },
  "specialtyTerms": {
    "opendock": "Opendock",
    "warehouses": "Entrepôt | Entrepôts",
    "carrierContacts": "Contact transporteur | Contacts transporteur",
    "loadTypes": "Type de chargement | Types de chargement",
    "docks": "Quai | Quais",
    "appointments": "Rendez-vous | Rendez-vous",
    "users": "Utilisateur | Utilisateurs",
    "organizations": "Organisation | Organisations",
    "orgs": "Org | Orgs",
    "companies": "Entreprise | Entreprises",
    "referenceNumber": "Numéro de référence",
    "refNumber": "Numéro de référence",
    "status": "Statut",
    "orgLoadTypes": "Types de chargement de l'organisation",
    "schedulingPortal": "Portail de planification",
    "customFields": "champ personnalisé | champs personnalisés",
    "interval": "Intervalle",
    "drivers": "Conducteur | Conducteurs",
    "carriers": "Transporteur | Transporteurs",
    "tags": "Étiquette | Étiquettes",
    "yardManagement": "Gestion de la cour",
    "carrier": "transporteur | transporteurs",
    "assets": "Actif | Actifs",
    "tvMode": "Mode TV",
    "gridView": "Vue grille",
    "listView": "Vue liste",
    "gateManagement": "Gestion des accès",
    "selfCheckIn": "auto-enregistrement",
    "gateFeed": "Flux d'accès"
  },
  "appointmentStatuses": {
    "NoShow": "Absence",
    "Cancelled": "Annulé",
    "Requested": "Demandé",
    "Scheduled": "Planifié",
    "Arrived": "Arrivé",
    "InProgress": "En cours",
    "Completed": "Terminé",
    "Reserves": "Réservé"
  },
  "appointmentTypes": {
    "standard": "Standard",
    "reserved": "Réservé",
    "reserve": "Réserve"
  },
  "appointmentCreatorTypes": {
    "warehouseUser": "Utilisateur de l'entrepôt",
    "carrier": "Transporteur"
  },
  "roles": {
    "base": "De base",
    "carrier": "Transporteur",
    "carrierAdmin": "Admin transporteur",
    "spectator": "Spectateur",
    "attendant": "Préposé",
    "operator": "Opérateur",
    "admin": "Administrateur",
    "owner": "Propriétaire",
    "internal": "Interne",
    "god": "Super utilisateur"
  },
  "weekdays": {
    "sunday": "Dimanche",
    "monday": "Lundi",
    "tuesday": "Mardi",
    "wednesday": "Mercredi",
    "thursday": "Jeudi",
    "friday": "Vendredi",
    "saturday": "Samedi"
  },
  "weekdaysAbbr": {
    "sun": "Dim",
    "mon": "Lun",
    "tue": "Mar",
    "wed": "Mer",
    "thu": "Jeu",
    "fri": "Ven",
    "sat": "Sam"
  },
  "buttons": {
    "nevermind": "Peu importe",
    "select": "Sélectionner",
    "send": "Envoyer",
    "confirm": "Confirmer",
    "next": "Suivant",
    "previous": "Précédent",
    "create": "Créer",
    "edit": "Modifier",
    "save": "Enregistrer",
    "yesDelete": "Oui, supprimer",
    "skipCreation": "Ignorer la création",
    "cancel": "Annuler",
    "export": "Exporter",
    "saveChanges": "Enregistrer les modifications",
    "exportData": "Exporter les données",
    "resetToDefault": "Réinitialiser par défaut"
  },
  "tooltips": {
    "notAvailable": "Non disponible",
    "notAvailableForUserRole": "Non disponible pour votre rôle d'utilisateur."
  },
  "errors": {
    "unkownError": "Une erreur inconnue est survenue.",
    "thisFieldIsRequired": "Ce champ est requis",
    "passwordDoesNotMeetRequirements": "Le mot de passe ne respecte pas les exigences",
    "emailMustBeValid": "L'adresse courriel doit être valide",
    "pleaseEnterAValidPhoneNumber": "Veuillez entrer un numéro de téléphone valide",
    "pleaseEnterAValidUrl": "Veuillez entrer une URL valide",
    "invalidHour": "Heure invalide",
    "invalidMinute": "Minute invalide",
    "pleaseSelectAmOrPm": "Sélectionnez AM ou PM",
    "pleaseEnterACompleteDateAndTime": "Entrez une date et une heure complètes",
    "mustBeANumber": "Doit être un nombre",
    "mustBeAPositiveInteger": "Doit être un entier positif",
    "mustBeAWholeNumber": "Doit être un nombre entier",
    "isNotAValidNumber": "n'est pas un nombre valide",
    "invalidUuid": "UUID invalide",
    "dateMustNotBeInThePast": "La date ne doit pas être dans le passé",
    "mustBeWithin24HoursOfStartTime": "doit être dans les 24 heures suivant l'heure de début",
    "pleaseSelectAtLeast": "Veuillez sélectionner au moins {requiredCount} {itemName} | Veuillez sélectionner au moins {requiredCount} {itemName}s",
    "cannotSelectMoreThan": "Impossible de sélectionner plus de {limit} {itemName} | Impossible de sélectionner plus de {limit} {itemName}s",
    "fieldMustEqual": "Le champ doit être égal à {value}",
    "mustBeXCharacters": "Doit comporter {length} caractère | Doit comporter {length} caractères",
    "mustBeAtLeastXCharacters": "Doit comporter au moins {min} caractère | Doit comporter au moins {min} caractères",
    "mustBeAtMostXCharacters": "Doit comporter au maximum {max} caractère | Doit comporter au maximum {max} caractères",
    "mustBeBetweenXAndYCharactersLong": "Doit comporter entre {min} et {max} caractères",
    "mustBeNumberBetweenXAndY": "Doit être un nombre entre {min} et {max}",
    "mustBeNumberGreaterThan": "Doit être un nombre supérieur ou égal à {min}",
    "mustBeNumberLessThan": "Doit être un nombre inférieur à {max}",
    "mustHaveAtLeast8Characters": "Doit contenir au moins 8 caractères",
    "mustContainUpperCaseAndLowerCase": "Doit contenir des majuscules et des minuscules",
    "mustContainAtLeastOneLetter": "Doit contenir au moins une lettre",
    "mustContainAtLeastOneSpecialCharacter": "Doit contenir au moins un caractère spécial",
    "mustContainAtLeastOneNumber": "Doit contenir au moins un chiffre",
    "atLeastOneReferenceNumberIsRequired": "Au moins un {refNumberDisplayName} est requis",
    "mustBeAValidNumber": "Doit être un nombre valide"
  },
  "warehouseAmenities": {
    "lumperServices": "Services de déchargement (lumper)",
    "overnightParking": "Stationnement de nuit",
    "driversRestroom": "Toilettes pour conducteurs",
    "freeWiFi": "Wi-Fi gratuit"
  },
  "warehousePPERequirements": {
    "safetyBoots": "Bottes de sécurité",
    "safetyGlasses": "Lunettes de sécurité",
    "gloves": "Gants",
    "hardHat": "Casque de sécurité",
    "faceMask": "Masque facial",
    "noSmoking": "Interdiction de fumer",
    "longPants": "Pantalons longs",
    "longSleeves": "Manches longues",
    "highVisibilityVest": "Gilet haute visibilité",
    "hairAndBeardNet": "Réseau pour cheveux et barbe"
  },
  "auditLog": {
    "header": "Journal d'audit",
    "viewAuditLog": "Voir le journal d'audit",
    "noAuditLogEvents": "Aucun événement dans le journal d'audit",
    "timelineForAllUpdatesMadeToThis": "Chronologie de toutes les mises à jour effectuées sur ceci",
    "hasTheWords": "contient les mots",
    "eventsFromDate": "Événements à partir de la date",
    "searchEvents": "Rechercher des événements",
    "by": "par",
    "appointmentUpdatesTimeline": "Historique du rendez-vous :",
    "moreUpdates": "{count} autres mises à jour",
    "emailSubscribersUpdated": "Abonnés e-mail mis à jour",
    "detailsUpdated": "Détails mis à jour",
    "recurrenceCreated": "Récurrence créée",
    "recurrenceDeleted": "Récurrence supprimée",
    "rescheduled": "{label} reprogrammé",
    "etaUpdated": "ETA mis à jour",
    "emailNotifications": "Notifications par e-mail",
    "carrierContactUpdated": "Contact transporteur mis à jour",
    "reserveTransferred": "Réservation transférée",
    "tagsUpdated": "Étiquettes mises à jour",
    "scheduled": "{label} planifié",
    "statusUpdated": "Statut mis à jour",
    "timeUpdated": "Heure de {arrived} mise à jour",
    "dwellTimeUpdated": "Temps de séjour mis à jour",
    "everyXAtXUntilX": "Tous les {weekDays} à {endTime} jusqu'au {endDate}",
    "opendockTeam": "Équipe Opendock",
    "unknownUser": "Utilisateur inconnu",
    "deleted": "Supprimé",
    "hasBeenCleared": "a été effacé",
    "actionUpdated": "mis à jour",
    "actionCreated": "Créé",
    "actionDeleted": "Supprimé",
    "noAction": "Aucune action",
    "emptyValue": "Valeur vide"
  },
  "timeline": {
    "createdTheTask": "créé la tâche",
    "startedTheTask": "commencé la tâche",
    "blockedTheTask": "bloqué la tâche",
    "unblockedTheTask": "débloqué la tâche",
    "completedTheTask": "terminé la tâche",
    "cancelledTheTask": "annulé la tâche",
    "cancelledTheReserve": "annulé la réserve",
    "cancelledTheReservationForSpot": "annulé la réserve de {areaName} - {spotCode} pour cette tâche",
    "reservedSpotForThisTask": "réservé {areaName} - {spotCode} pour cette tâche",
    "reservedTheSpot": "réservé l’emplacement",
    "reason": "Raison : {reason}",
    "addedA": "ajouté",
    "reportedAn": "signalé",
    "clearedThe": "nettoyé",
    "flaggedTheTask": "marqué la tâche",
    "flaggedTheTaskAs": "marqué la tâche comme",
    "unflaggedTheTask": "démarqué la tâche",
    "unflaggedTheTaskAs": "démarqué la tâche comme",
    "updatedTheTask": "mis à jour la tâche",
    "removedTask": "supprimé de la tâche",
    "attachments": "pièces jointes",
    "confirmedTheLocation": "a confirmé la localisation",
    "reportedAsMissing": "a signalé comme manquant",
    "noActivityYet": "Aucune activité pour le moment",
    "noAssignee": "Aucun assigné",
    "failedToFetchYardTaskTimeline": "Échec de récupération de la chronologie de la tâche de cour",
    "failedToCreateComment": "Échec de création de commentaire"
  },
  "yardSpotStatusDialog": {
    "headers": {
      "actionThisSpot": "{action} cette Place?"
    },
    "dropDownItems": {
      "cleaning": "Nettoyage",
      "underMaintenance": "En Maintenance",
      "blockedByEquipment": "Bloqué par Équipement",
      "safetyInspection": "Inspection de Sécurité",
      "routineInspection": "Inspection de Routine",
      "reserved": "Réservé",
      "repairsNeeded": "Réparations Nécessaires",
      "damage": "Dommage"
    },
    "labels": {
      "reason": "Raison",
      "additionalNotes": "Notes Supplémentaires"
    },
    "placeholders": {
      "selectAReason": "Sélectionnez une raison",
      "enterAdditionalNotes": "Entrez des notes supplémentaires"
    },
    "messages": {
      "thisSpotWillRemainUnavailable": "Cette place restera indisponible pour l'attribution d'actifs jusqu'à ce qu'elle soit définie comme ouverte à nouveau.",
      "thisDoorWillBeSetAsOpen": "Cette porte sera définie comme ouverte et sera à nouveau disponible pour l'attribution d'actifs.",
      "assetInTransitClosingWillBlockMove": "L'actif {assetCode} est en transit vers cette place. La fermer empêchera que le déplacement soit complété."
    }
  },
  "tasks": {
    "presenter": {
      "unassigned": "Non assigné",
      "noDueDate": "Aucune échéance",
      "fromAnySpot": "À partir de n'importe quel emplacement",
      "toAnySpot": "Vers n'importe quel emplacement",
      "anyAsset": "N'importe quel actif",
      "types": {
        "move": "Déplacer"
      },
      "status": {
        "toDo": "À Faire",
        "inProgress": "En Progrès",
        "completed": "Terminé",
        "canceled": "Annulé"
      },
      "issue": "Problème",
      "relatedEntity": {
        "spotArea": "Zone",
        "spot": "Emplacement",
        "asset": "Actif"
      }
    }
  },
  "readyForPickupNotificationDialog": {
    "title": "Notification de Prêt pour Enlèvement",
    "messages": {
      "body": "Envoyez un e-mail aux contacts suivants pour les informer que l'actif {assetContainerCode} est prêt pour être récupéré à {warehouseName}.",
      "notificationSent": "Notification envoyée avec succès.",
      "notificationFailed": "Échec de l'envoi de la notification. Veuillez réessayer."
    },
    "labels": {
      "notifyTheseContacts": "Notifier ces contacts :",
      "suggestedContacts": "Contacts suggérés :"
    },
    "buttons": {
      "skipNotification": "Ignorer la notification"
    }
  }
}
